import React, { useState } from 'react';
import './style.scss';
import '../style.scss';
import { Modal } from 'antd';
import { formatVND } from '../constant/contanst';

const PaymentInfo = ({ msisdn, packageSelected, dataTransaction, countryName, isModal, setIsModal }) => {
  const phoneNumber =  msisdn ? (msisdn.slice(0, 2) === '84' ? `0${msisdn?.slice(2)}` : msisdn) : ''

  return (
    <>
      <Modal
        className="qr-code__modal-custom"
        title={null}
        footer={null}
        closable={null}
        open={isModal}
      >
        <div className="qr-code-modal-info">
          <div className="qr-code__info-title">Thông tin gói cước</div>
          <div className="qr-code__info-detail">
            <div className="qr-code__info--item">
              <div className="info-txt-normal">Tên gói cước</div>
              <div className="info-txt-bold">{packageSelected?.packageName}</div>
            </div>
            <div className="qr-code__info--item">
              <div className="info-txt-normal">Số thuê bao</div>
              <div className="info-txt-bold">{phoneNumber}</div>
            </div>
            {
              countryName ?
              <div className="qr-code__info--item">
                <div className="info-txt-normal">Quốc gia</div>
                <div className="info-txt-bold">{countryName}</div>
              </div>
              :
              <></>
            }
            <div className="qr-code__info--item">
              <div className="info-txt-normal">Giá tiền gói</div>
              <div className="info-txt-bold">{formatVND(packageSelected?.price)}</div>
            </div>
            <div className="qr-code__info--item">
              <div className="info-txt-normal">Chi tiết gói</div>
              <div className="package--des info-txt-italic" dangerouslySetInnerHTML={{ __html: packageSelected?.description }} />
            </div>
          </div>
          <div className="divider-dashed"></div>
          <div className="qr-code__info-detail">
            <div className="qr-code__info--item">
              <div className="info-txt-normal">Số tiền gốc</div>
              <div className="info-txt-bold">{formatVND(dataTransaction?.amount)}</div>
            </div>
            <div className="qr-code__info--item">
              <div className="info-txt-normal">Phí giao dịch</div>
              <div className="info-txt-bold success">{dataTransaction?.feeAmount === 0 ? "Miễn phí" : `${formatVND(dataTransaction?.feeAmount)}`}</div>
            </div>
            <div className="qr-code__info--item">
              <div className="info-txt-normal">Chiết khấu</div>
              <div className="info-txt-bold primary">-{formatVND(dataTransaction?.discountAmount)}</div>
            </div>
          </div>
          <div className="divider-dashed"></div>
          <div className="qr-code__info-detail">
            <div className="qr-code__info--item">
              <div className="info-txt-normal">Tổng tiền</div>
              <div className="info-txt-bold amount">{formatVND(dataTransaction?.finalAmount)}</div>
            </div>
          </div>
          <button 
            className="qr-code__btn-custom border-primay"
            onClick={() => setIsModal(false)}
          >
            Trở lại
          </button>
        </div>
      </Modal>
    </>
  );
}

export default React.memo(PaymentInfo);
